import React from 'react'
import Header from '../components/Header'
import Schedule from '../components/Home/Schedule'
import { BottomNavBar } from '../components/Header';
import useAuthStore from '../stores/authStore';

function Home() {
  const { user } = useAuthStore();
  return (
    <div className='Home'>
        <Header />

        <div className="Home__container">
            {user && user.fullName && (
              <div style={{fontSize: 22, fontWeight: 500, marginTop: 18, marginBottom: 18}}>
                Привет! {user.fullName}
              </div>
            )}
            <Schedule />
        </div>
        <BottomNavBar />
    </div>
  )
}

export default Home